export function maskCnpj(value: string|undefined) {
  if (!value) return '';
  //return formatCNPJ(value);

  // Remove tudo que não for alfanumérico (mantém A-Z, a-z, 0-9)
  const limpo = value.replace(/[^A-Za-z0-9]/g, '');
  
  // Verifica se tem 14 caracteres
  if (limpo.length !== 14) {
    return limpo; // Retorna sem formatação se não tiver 14 chars
  }
  
  // Aplica a máscara: XX.XXX.XXX/XXXX-XX
  return limpo.replace(/^(\w{2})(\w{3})(\w{3})(\w{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

export function maskCpf(value: string|undefined) {
  if (!value) return '';
  //return formatCPF(value);
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{3})(\d)/, "$1.$2"); //Coloca ponto entre o terceiro e o quarto dígitos
  value = value.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o sexto e o sétimo dígitos
  value = value.replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4"); //Coloca um hífen antes dos 2 dígitos verificadores
  return value;
};

export const maskCep = (value: string|undefined) => {
  if (!value) return '';
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2-$3"); //Coloca ponto entre o quinto e o sexto dígitos
  return value;
};

export function maskData(value: string|undefined) {
  if (!value) return '';
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{2})(\d)/, "$1/$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  value = value.replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3"); //Coloca ponto entre o quinto e o sexto dígitos
  return value;
}

export function masktelefone(value: string|undefined) {
  if (!value) return '';
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{0})(\d)/, `$1($2`); //Coloca ponto entre o segundo e o terceiro dígitos
  value = value.replace(/(\d{2})(\d)/, `$1) $2`); //Coloca ponto entre o segundo e o terceiro dígitos
  value = value.replace(/(\d{4})(\d)/, `$1-$2`); //Coloca ponto entre o segundo e o terceiro dígitos
  return value;
}

export function masktelefoneSemDdd(value: string|undefined) {
  if (!value) return '';
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/(\d{4})(\d)/, `$1-$2`); //Coloca ponto entre o segundo e o terceiro dígitos
  return value;
}

export function maskNumeroProcesso(value: string|undefined) {
  if (!value) return '';
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{5})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  value = value.replace(/^(\d{5})\.(\d{6})(\d)/, "$1.$2/$3"); //Coloca ponto entre o quinto e o sexto dígitos
  value = value.replace(/\/(\d{4})(\d)/, "/$1-$2"); //Coloca uma barra entre o oitavo e o nono dígitos
  return value;
}

export function maskCNPB(value: string|undefined) {
  if (!value) return '';
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  value = value.replace(/^(\d{4})(\d{4})(\d)/, "$1-$2-$3"); //Coloca ponto entre o segundo e o terceiro dígitos
  return value;
}
